import styled from 'styled-components';
import { positions } from 'utils/styles';

export const Ranking = styled.div.attrs({
    className: 'ranking',
})`
    background: #fff;
    border: 2px solid var(--primary);
    border-radius: 0.8rem;
    position: relative;

    &::before {
        background: transparent no-repeat 100% 100%;
        background-image: url(https://www.openstartups.net/ranking/img/bg_05.jpg);
        background-size: 100% 100%;
        border-radius: 0.7rem;
        content: '';
        position: absolute;
        ${positions(0, 0, 0, 0)}

        transform: scaleX(-1);
    }

    & > * {
        position: relative;
    }
`;
